<div class="content-box">
  <app-input-buscar></app-input-buscar>

  <section class="todos-servicos" aria-labelledby="todos-servicos-titulo">

    <app-breadcrumb [pagina]="categoriaAtiva()?.titulo ?? 'Todos os serviços'"></app-breadcrumb>

    <div>
      <app-todos-servicos-usuario-logado></app-todos-servicos-usuario-logado> 
    </div>

    <p class="todos-servicos-estado" role="status" aria-live="polite">
      @if (carregando()) {
      Carregando os serviços...
      }
    </p>

    @if (falhou()) {
    <div class="todos-servicos-aviso" role="alert">
      <p>Não foi possível carregar os serviços agora. Tente novamente em instantes.</p>
      <button type="button" class="todos-servicos-aviso-acao" (click)="recarregar()">
        Tentar novamente
      </button>
    </div>
    } @else if (vazio()) {
    <p class="todos-servicos-aviso">Nenhum serviço publicado até o momento.</p>
    } @else {
    <div class="todos-servicos-layout">
      <nav class="todos-servicos-menu" aria-label="Categorias de serviço">
        <ul class="todos-servicos-menu-lista">
          @for (categoria of categorias(); track categoria.id) {
          <li>
            <button type="button" class="todos-servicos-menu-item"
              [class.todos-servicos-menu-item-ativo]="categoria.id === categoriaSelecionada()"
              [attr.aria-current]="categoria.id === categoriaSelecionada() ? 'true' : null"
              (click)="selecionarCategoria(categoria.id)">
              <i-lucide [name]="categoria.icone" size="18" aria-hidden="true"></i-lucide>
              {{ categoria.titulo }}
            </button>
          </li>
          }
        </ul>
      </nav>

      <div class="todos-servicos-conteudo">
        <h1 class="todos-servicos-titulo" id="todos-servicos-titulo">
          <i class="fa-solid fa-star todos-servicos-titulo-icone" aria-hidden="true"></i>
          @if (categoriaAtiva(); as ativa) {
          Serviços disponíveis em {{ ativa.titulo }}
          } @else {
          Serviços disponíveis
          }
        </h1>

        <div class="todos-servicos-busca">
          <i-lucide class="todos-servicos-busca-icone" name="search" size="18" aria-hidden="true"></i-lucide>

          <label class="todos-servicos-busca-label" for="todos-servicos-busca">Buscar serviço</label>
          <input id="todos-servicos-busca" class="todos-servicos-busca-input" type="search" autocomplete="off"
            placeholder="Buscar serviço..." [value]="termoBusca()" (input)="aoBuscar($event)" />

          @if (termoBusca()) {
          <button type="button" class="todos-servicos-busca-limpar" (click)="limparBusca()" aria-label="Limpar busca">
            <i-lucide name="x" size="16" aria-hidden="true"></i-lucide>
          </button>
          }
        </div>

        <ul class="todos-servicos-lista">
          @for (servico of servicos(); track servico.id) {
          <li class="todos-servicos-item" [class.todos-servicos-item-aberto]="estaAberto(servico.id)">
            <div class="todos-servicos-item-cabecalho">
              <h2 class="todos-servicos-item-heading">
                <button type="button" class="todos-servicos-item-botao" [attr.aria-expanded]="estaAberto(servico.id)"
                  [attr.aria-controls]="'todos-servicos-painel-' + servico.id" [id]="'todos-servicos-botao-' + servico.id"
                  (click)="alternarServico(servico.id)">
                  <span class="todos-servicos-item-titulo">{{ servico.titulo }}</span>
                  <i-lucide class="todos-servicos-item-seta"
                    [name]="estaAberto(servico.id) ? 'chevron-up' : 'chevron-down'" size="18"
                    aria-hidden="true"></i-lucide>
                </button>
              </h2>

              <button type="button" class="todos-servicos-item-favorito"
                [class.todos-servicos-item-favorito-ativo]="ehFavorito(servico.id)"
                [attr.aria-pressed]="ehFavorito(servico.id)" [attr.aria-label]="rotuloFavorito(servico)"
                [attr.title]="dicaFavorito(servico)" [disabled]="estaGravando(servico.id)"
                [attr.aria-busy]="estaGravando(servico.id) || null" (click)="alternarFavorito(servico)">
                <i-lucide name="star" size="18" aria-hidden="true"></i-lucide>
              </button>
            </div>

            @if (estaAberto(servico.id)) {
            <div class="todos-servicos-item-painel" role="region" [id]="'todos-servicos-painel-' + servico.id"
              [attr.aria-labelledby]="'todos-servicos-botao-' + servico.id">
              <p class="todos-servicos-item-descricao">{{ servico.descricao }}</p>

              @if (servico.link) {
              @if (servico.externo) {
              <a class="todos-servicos-item-acao" [href]="servico.link" target="_blank" rel="noopener">
                {{ servico.rotuloLink ?? 'Acesse aqui' }}
                <i-lucide name="external-link" size="15" aria-hidden="true"></i-lucide>
              </a>
              } @else {
              <a class="todos-servicos-item-acao" [routerLink]="servico.link">
                {{ servico.rotuloLink ?? 'Acesse aqui' }}
              </a>
              }
              }
            </div>
            }
          </li>
          } @empty {
          @if (!carregando()) {
          <li class="todos-servicos-vazio">
            @if (termoBusca()) {
            Nenhum serviço encontrado para "{{ termoBusca() }}" em {{ categoriaAtiva()?.titulo }}.
            } @else {
            Nenhum serviço cadastrado em {{ categoriaAtiva()?.titulo }} até o momento.
            }
          </li>
          }
          }

          <app-links-dinamicos local="Todos os Serviços" variante="lista"></app-links-dinamicos>
        </ul>
      </div>
    </div>
    }
  </section>
</div>